import { render, staticRenderFns } from "./BaseCheckBox.vue?vue&type=template&id=1aacb122&"
import script from "./BaseCheckBox.vue?vue&type=script&lang=js&"
export * from "./BaseCheckBox.vue?vue&type=script&lang=js&"
import style0 from "./BaseCheckBox.vue?vue&type=style&index=0&id=1aacb122&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports